<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("cml_rate_base") }}</h4>
                    <button
                       v-if="permision_role.method_create"
                      class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="createData()"
                    >
                      <i class="link-icon" data-feather="plus"></i>
                      {{ $t("createNew") }}
                    </button>
                     
                    <button
                      v-if="permision_role.method_read"
                      class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="downloadData()"
                    >
                       <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
                  </div>
  
                  <div class="card-body">
                    <vue-good-table
                      title="list-billing-ratebase-cml"
                      ref="list-billing-ratebase-cml"
                      :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns"
                     
                    >
  
                    <div slot="table-actions">
                      {{ $t("no_select_data") }}
                    </div>
                    <div slot="selected-row-actions">
                      <button v-if="permision_role.method_delete" class="btn btn-danger btn-xs" style="margin-right:20px;" @click="deleteMass"> <i
                          class="mdi mdi-send-outline"></i> {{ $t("DeleteTxt") }}</button>
  
                        <!--<button class="btn btn-success btn-xs" @click="removeOrderHeaderIds">
                            <i class="mdi mdi-close"></i> {{ $t("cancel_order_txt") }} 
                        </button>-->
                    </div>
  
                       <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                              <a
                                href="#"
                                v-if="permision_role.method_read"
                                title="Detail"
                                @click.prevent="
                                  detailData(props.index, props.row)
                                "
                              >
                                <i class="mdi mdi-eye" style="font-size:16px"></i>
                                
                              </a>
                              <a
                                href="#"
                                v-if="permision_role.method_update"
                                title="Edit"
                                @click.prevent="editData(props.index, props.row)"
                              >
                                <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
                                
                              </a>
  
                              <a
                                href="#"
                                v-if="permision_role.method_delete"
                                title="Delete"
                                @click.prevent="
                                  deleteData(props.index, props.row)
                                "
                              >
                                <i class="mdi mdi-trash-can-outline" style="font-size:16px"></i> 
                              </a>
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "FulfillmentIndexCML",
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        isLoading: false,
        errors: [],
        permision_role:[],
        langs: ["id", "en"],
        detailUser: [],
        idRateBases:[],
        detailDivisi: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },
        columns: [
            {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: this.$t("idRateBase"),
            field: "idRateBase",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("idRateBase"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("chargeCategory_txt"),
            field: "chargeCategory",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("chargeCategory_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("chargeType_txt"),
            field: "chargeType",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("chargeType_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("rateBaseName_txt"),
            field: "rateBaseName",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("rateBaseName_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("rateBaseDesc_txt"),
            field: "rateBaseDesc",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("rateBaseDesc_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("SAPMaterialCode"),
            field: "SAPMaterialCode",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("SAPMaterialCode"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("statusTxt"),
            field: "status",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("statusTxt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
        ],
        rows: [],
        rowsSelection:[],
      };
    },
    watch: {},
    methods: {
  
      selectionChanged(ev) {
        this.rowsSelection = [];
        this.idRateBases   = [];
        this.rowsSelection = ev.selectedRows;
  
        this.rowsSelection.forEach((item) => {
          this.idRateBases.push(item.idRateBase);
  
        });
  
      },
  
      deleteMass() {
        
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourDataSend"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            //this.loadingSubmiting();
            this.loading();
            let data = {
              idRateBases: this.idRateBases
            }
            const baseURI =
              this.$settings.endPointBilling + "dashboard/cml-billing/ratebase/delete-mass";
            this.$http
              .post(baseURI, data)
              .then((response) => {
                //this.loading();
                  this.success(response.data.datas.messages);
                  this.idRateBases = []
                  this.loadItems();
              })
              .catch((error) => {
                this.loading();
               
                if(error.code == "ECONNABORTED"){
                  this.error(this.$t("check_internet_connection_txt"));
                  
                }else{
  
                    if (error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        }else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        }else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        }else{
                            this.$router.push('/page-not-found');
                        }
                    }
  
                }

              });
          }else{
            this.isLoading = false;
          }
        });
  
      },
  
      removeOrderHeaderIds() {
        this.idRateBases = [];
        this.$refs['list-billing-ratebase-cml'].unselectAllInternal()
      },
  
      downloadData() {
        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/ratebase";
        var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        var file_name = "download_" + CurrentDate + ".xlsx";
   
        return this.$http
          .get(
            baseURI +
              `?sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&chargeCategory=${this.serverParams.columnFilters.chargeCategory}&chargeType=${this.serverParams.columnFilters.chargeType}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&rateBaseName=${this.serverParams.columnFilters.rateBaseName}&SAPMaterialCode=${this.serverParams.columnFilters.SAPMaterialCode}&idRateBase=${this.serverParams.columnFilters.idRateBase}&download=download`,
            {
              responseType: "blob",
            }
          )
          .then((response) => {
           
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
      },
   
      createData() {
        window.location.href = "/billing-cml/ratebase/create";
      },
   
  
      editData(index, row) {
        var params = this.$onRandom(row.idRateBase);
        window.location.href = "/billing-cml/ratebase/edit/" + params;
      },
  
      detailData(index, row) {
        var params = this.$onRandom(row.idRateBase);
        window.location.href = "/billing-cml/ratebase/detail/" + params;
      },
  
      deleteData(index, row, status) {
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourDataDelete"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            var formData = {
              status: status,
            };
            const baseURI =
              this.$settings.endPointBilling + "dashboard/cml-billing/ratebase/delete/" + row.idRateBase;
            this.$http
              .delete(baseURI, formData,{ timeout: 60000 })
              .then((response) => {
                this.loading();
                if (response.data.status === 200) {
                  this.success(response.data.datas.messages);
                  this.loadItems();
                } else {
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
                }
              }).catch((error) => {
                this.loading();
                
                
                if(error.code == "ECONNABORTED"){
                  this.error(this.$t("check_internet_connection_txt"));
                  
                }else{
  
                    if (error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        }else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        }else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        }else{
                            this.$router.push('/page-not-found');
                        }
                    }
  
                }

              });
          }else{
            this.isLoading = false;
          }
        });
      },
  
      // load items is what brings back the rows from server
      loadItems() {
        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/ratebase";
        this.isLoading = true;
  
        return this.$http
          .get(
             baseURI +
             `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&chargeCategory=${this.serverParams.columnFilters.chargeCategory}&chargeType=${this.serverParams.columnFilters.chargeType}&rateBaseName=${this.serverParams.columnFilters.rateBaseName}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&SAPMaterialCode=${this.serverParams.columnFilters.SAPMaterialCode}&idRateBase=${this.serverParams.columnFilters.idRateBase}`,
            { timeout: 60000 })
          .then((response) => {
            this.isLoading = false;
            this.rows = response.data.datas.data;
            this.totalRecords = response.data.datas.total;
          }).catch((error) => {
                this.loading();
                
                
                if(error.code == "ECONNABORTED"){
                  this.error(this.$t("check_internet_connection_txt"));
                  
                }else{
  
                    if (error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        }else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        }else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        }else{
                            this.$router.push('/page-not-found');
                        }
                    }
  
                }

              });
      },
  
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
        this.loadItems();
      },
  
      onColumnFilter(params) {
        this.updateParams(params);
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage });
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
      },
  
      onPerPageChange(params) {
        this.updateParams({ per_page: params.currentPerPage });
      },
  
      resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
          }
        }
      },
  
      success(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "success",
          title: kata,
        });
      },
  
      error(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: kata,
        });
      },
  
      fade(sType) {
        this.isLoading = sType;
      },
  
      loading() {
        this.fade(true);
        setTimeout(() => {
          this.isLoading = false;
        }, 1000); // hide the message after 3 seconds
      },
  
      fetchIt() {
        const userDatas     = this.$getUserInfo();
        this.detailUser     = userDatas.sub;
        // this.permision_role = userDatas.sub.permision_role;
        let rolePermision = [];
        userDatas.sub.permision_role.forEach(function(permision){
          if(permision.permission.controller == 'RatebaseCmlController'){
            rolePermision = permision;
          }
        });
  
        if(!rolePermision.method_read){
          this.$router.push("/authorized-error");
        }
        this.permision_role = rolePermision;
  
      },
  
    

        logout(){

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },
    },
    events: {},
    created: function () {},
    mounted() {
      this.fetchIt();
      this.loading();
    },
  };
  </script>
  <style scoped>
  .blur-content{
    filter: blur(5px); 
  }
  </style>